import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';

import Button from '../../components/ui/Button';
import JobCard from './components/JobCard';
import FilterPanel from './components/FilterPanel';
import SortControls from './components/SortControls';
import EmptyState from './components/EmptyState';

const JobListings = () => {
  const [filters, setFilters] = useState({
    keyword: '',
    location: 'all',
    experience: 'all',
    category: 'all',
    jobTypes: [],
    salaryMin: 0,
    salaryMax: 50,
    isRemote: false,
    companySize: 'all'
  });

  const [sortBy, setSortBy] = useState('relevance');
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const jobsPerPage = 12;

  const mockJobs = [
  {
    id: 1,
    title: "Senior Software Engineer",
    companyName: "Tech Innovations Pvt Ltd",
    companyLogo: "https://images.unsplash.com/photo-1730472528744-399397ac0b76",
    companyLogoAlt: "Modern tech company logo with blue gradient and geometric design on white background",
    location: "Bangalore",
    experience: "5-8 years",
    jobType: "Full-time",
    salaryMin: 1500000,
    salaryMax: 2500000,
    isRemote: true,
    tags: ["React", "Node.js", "AWS", "MongoDB"],
    postedDate: "2025-11-25T10:30:00",
    applicants: 45,
    isWishlisted: false,
    category: "it",
    companySize: "medium"
  },
  {
    id: 2,
    title: "Product Manager",
    companyName: "StartupHub India",
    companyLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_14d3132d8-1764221709869.png",
    companyLogoAlt: "Startup company logo featuring orange rocket icon with modern typography on dark background",
    location: "Mumbai",
    experience: "3-6 years",
    jobType: "Full-time",
    salaryMin: 1800000,
    salaryMax: 3000000,
    isRemote: false,
    tags: ["Product Strategy", "Agile", "Analytics", "Leadership"],
    postedDate: "2025-11-26T14:20:00",
    applicants: 67,
    isWishlisted: true,
    category: "it",
    companySize: "startup"
  },
  {
    id: 3,
    title: "Data Analyst",
    companyName: "Analytics Pro Solutions",
    companyLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_18e06b39f-1764221708774.png",
    companyLogoAlt: "Professional analytics company logo with graph chart symbol in green on white circular background",
    location: "Pune",
    experience: "2-4 years",
    jobType: "Full-time",
    salaryMin: 800000,
    salaryMax: 1200000,
    isRemote: true,
    tags: ["Python", "SQL", "Tableau", "Excel"],
    postedDate: "2025-11-24T09:15:00",
    applicants: 89,
    isWishlisted: false,
    category: "it",
    companySize: "small"
  },
  {
    id: 4,
    title: "UI/UX Designer",
    companyName: "Creative Minds Studio",
    companyLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_17d747bac-1764221710058.png",
    companyLogoAlt: "Creative design studio logo with colorful palette icon and brush strokes on light background",
    location: "Delhi NCR",
    experience: "3-5 years",
    jobType: "Full-time",
    salaryMin: 1000000,
    salaryMax: 1600000,
    isRemote: true,
    tags: ["Figma", "Adobe XD", "Prototyping", "User Research"],
    postedDate: "2025-11-26T16:45:00",
    applicants: 34,
    isWishlisted: false,
    category: "design",
    companySize: "small"
  },
  {
    id: 5,
    title: "Sales Manager",
    companyName: "Enterprise Solutions Ltd",
    companyLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_1792cb87f-1764221710054.png",
    companyLogoAlt: "Corporate enterprise logo with blue shield emblem and professional typography on white background",
    location: "Hyderabad",
    experience: "4-7 years",
    jobType: "Full-time",
    salaryMin: 1200000,
    salaryMax: 2000000,
    isRemote: false,
    tags: ["B2B Sales", "Team Management", "CRM", "Negotiation"],
    postedDate: "2025-11-23T11:30:00",
    applicants: 56,
    isWishlisted: true,
    category: "sales",
    companySize: "large"
  },
  {
    id: 6,
    title: "Digital Marketing Specialist",
    companyName: "Growth Marketing Agency",
    companyLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_19b0982de-1764221708377.png",
    companyLogoAlt: "Marketing agency logo with megaphone icon in vibrant red and yellow gradient on white background",
    location: "Chennai",
    experience: "2-4 years",
    jobType: "Full-time",
    salaryMin: 600000,
    salaryMax: 1000000,
    isRemote: true,
    tags: ["SEO", "Google Ads", "Social Media", "Content Marketing"],
    postedDate: "2025-11-27T08:00:00",
    applicants: 78,
    isWishlisted: false,
    category: "sales",
    companySize: "small"
  },
  {
    id: 7,
    title: "HR Business Partner",
    companyName: "People First Consulting",
    companyLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_1599272b2-1764221710063.png",
    companyLogoAlt: "HR consulting firm logo with interconnected people icons in purple on light circular background",
    location: "Bangalore",
    experience: "5-8 years",
    jobType: "Full-time",
    salaryMin: 1400000,
    salaryMax: 2200000,
    isRemote: false,
    tags: ["Talent Management", "Employee Relations", "HR Strategy", "Compliance"],
    postedDate: "2025-11-25T13:20:00",
    applicants: 42,
    isWishlisted: false,
    category: "hr",
    companySize: "medium"
  },
  {
    id: 8,
    title: "Financial Analyst",
    companyName: "FinTech Innovations",
    companyLogo: "https://images.unsplash.com/photo-1658225282648-b199eb2a4830",
    companyLogoAlt: "Fintech company logo with currency symbol and upward arrow in gold on dark blue background",
    location: "Mumbai",
    experience: "3-5 years",
    jobType: "Full-time",
    salaryMin: 1100000,
    salaryMax: 1800000,
    isRemote: true,
    tags: ["Financial Modeling", "Excel", "Forecasting", "Risk Analysis"],
    postedDate: "2025-11-26T10:15:00",
    applicants: 61,
    isWishlisted: true,
    category: "finance",
    companySize: "startup"
  },
  {
    id: 9,
    title: "DevOps Engineer",
    companyName: "Cloud Systems India",
    companyLogo: "https://images.unsplash.com/photo-1650204767747-12db6c311f95",
    companyLogoAlt: "Cloud technology company logo with server and cloud icons in blue gradient on white background",
    location: "Pune",
    experience: "4-6 years",
    jobType: "Full-time",
    salaryMin: 1600000,
    salaryMax: 2400000,
    isRemote: true,
    tags: ["Docker", "Kubernetes", "CI/CD", "AWS"],
    postedDate: "2025-11-24T15:30:00",
    applicants: 38,
    isWishlisted: false,
    category: "it",
    companySize: "medium"
  },
  {
    id: 10,
    title: "Content Writer",
    companyName: "Digital Content Hub",
    companyLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_12cb1e03b-1764221710719.png",
    companyLogoAlt: "Content creation company logo with pen and paper icon in teal on light circular background",
    location: "Delhi NCR",
    experience: "1-3 years",
    jobType: "Full-time",
    salaryMin: 400000,
    salaryMax: 700000,
    isRemote: true,
    tags: ["SEO Writing", "Blog Posts", "Copywriting", "Research"],
    postedDate: "2025-11-27T09:45:00",
    applicants: 92,
    isWishlisted: false,
    category: "sales",
    companySize: "small"
  },
  {
    id: 11,
    title: "Manufacturing Engineer",
    companyName: "Industrial Solutions Ltd",
    companyLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_1bcd3882b-1764221715318.png",
    companyLogoAlt: "Manufacturing company logo with gear and factory icon in gray on white industrial background",
    location: "Ahmedabad",
    experience: "3-6 years",
    jobType: "Full-time",
    salaryMin: 900000,
    salaryMax: 1500000,
    isRemote: false,
    tags: ["Lean Manufacturing", "Quality Control", "Process Optimization", "AutoCAD"],
    postedDate: "2025-11-25T12:00:00",
    applicants: 29,
    isWishlisted: false,
    category: "manufacturing",
    companySize: "large"
  },
  {
    id: 12,
    title: "Business Analyst",
    companyName: "Consulting Partners India",
    companyLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_1dc23f52d-1764221708624.png",
    companyLogoAlt: "Business consulting firm logo with briefcase and chart icons in navy blue on white background",
    location: "Bangalore",
    experience: "2-5 years",
    jobType: "Full-time",
    salaryMin: 1000000,
    salaryMax: 1700000,
    isRemote: true,
    tags: ["Requirements Analysis", "SQL", "Business Intelligence", "Stakeholder Management"],
    postedDate: "2025-11-26T11:30:00",
    applicants: 54,
    isWishlisted: true,
    category: "consulting",
    companySize: "medium"
  },
  {
    id: 13,
    title: "Mobile App Developer",
    companyName: "AppTech Solutions",
    companyLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_18b80602f-1764221710822.png",
    companyLogoAlt: "Mobile app development company logo with smartphone icon in purple gradient on white background",
    location: "Hyderabad",
    experience: "3-5 years",
    jobType: "Full-time",
    salaryMin: 1300000,
    salaryMax: 2000000,
    isRemote: true,
    tags: ["React Native", "Flutter", "iOS", "Android"],
    postedDate: "2025-11-24T14:15:00",
    applicants: 47,
    isWishlisted: false,
    category: "it",
    companySize: "startup"
  },
  {
    id: 14,
    title: "Customer Success Manager",
    companyName: "SaaS Ventures India",
    companyLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_1d10f1e62-1764221711228.png",
    companyLogoAlt: "SaaS company logo with cloud and checkmark icon in green on light circular background",
    location: "Mumbai",
    experience: "4-7 years",
    jobType: "Full-time",
    salaryMin: 1200000,
    salaryMax: 1900000,
    isRemote: false,
    tags: ["Client Relations", "SaaS", "Account Management", "Communication"],
    postedDate: "2025-11-25T16:00:00",
    applicants: 36,
    isWishlisted: false,
    category: "sales",
    companySize: "startup"
  },
  {
    id: 15,
    title: "Quality Assurance Engineer",
    companyName: "TestPro Technologies",
    companyLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_1f4372781-1764221708056.png",
    companyLogoAlt: "QA testing company logo with magnifying glass and bug icon in red on white background",
    location: "Pune",
    experience: "2-4 years",
    jobType: "Full-time",
    salaryMin: 700000,
    salaryMax: 1200000,
    isRemote: true,
    tags: ["Selenium", "Test Automation", "Manual Testing", "JIRA"],
    postedDate: "2025-11-27T10:30:00",
    applicants: 71,
    isWishlisted: false,
    category: "it",
    companySize: "small"
  },
  {
    id: 16,
    title: "Graphic Designer",
    companyName: "Visual Arts Studio",
    companyLogo: "https://images.unsplash.com/photo-1726143947135-8fb529227001",
    companyLogoAlt: "Graphic design studio logo with colorful paint palette and brush icon on white background",
    location: "Chennai",
    experience: "2-4 years",
    jobType: "Full-time",
    salaryMin: 500000,
    salaryMax: 900000,
    isRemote: true,
    tags: ["Adobe Creative Suite", "Branding", "Print Design", "Digital Design"],
    postedDate: "2025-11-26T13:45:00",
    applicants: 83,
    isWishlisted: true,
    category: "design",
    companySize: "small"
  },
  {
    id: 17,
    title: "Data Scientist",
    companyName: "AI Research Labs",
    companyLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_14ad4a6d0-1764221711495.png",
    companyLogoAlt: "AI research company logo with neural network pattern in blue and purple gradient on dark background",
    location: "Bangalore",
    experience: "4-7 years",
    jobType: "Full-time",
    salaryMin: 2000000,
    salaryMax: 3500000,
    isRemote: true,
    tags: ["Machine Learning", "Python", "TensorFlow", "Deep Learning"],
    postedDate: "2025-11-25T09:00:00",
    applicants: 52,
    isWishlisted: false,
    category: "it",
    companySize: "medium"
  },
  {
    id: 18,
    title: "Operations Manager",
    companyName: "Logistics Pro India",
    companyLogo: "https://img.rocket.new/generatedImages/rocket_gen_img_15d6b6d62-1764221710570.png",
    companyLogoAlt: "Logistics company logo with truck and delivery box icon in orange on white background",
    location: "Delhi NCR",
    experience: "5-8 years",
    jobType: "Full-time",
    salaryMin: 1500000,
    salaryMax: 2300000,
    isRemote: false,
    tags: ["Supply Chain", "Process Improvement", "Team Leadership", "Logistics"],
    postedDate: "2025-11-24T11:20:00",
    applicants: 41,
    isWishlisted: false,
    category: "manufacturing",
    companySize: "large"
  }];


  const filterJobs = (jobs) => {
    return jobs?.filter((job) => {
      if (filters?.keyword && !job?.title?.toLowerCase()?.includes(filters?.keyword?.toLowerCase()) &&
      !job?.companyName?.toLowerCase()?.includes(filters?.keyword?.toLowerCase()) &&
      !job?.tags?.some((tag) => tag?.toLowerCase()?.includes(filters?.keyword?.toLowerCase()))) {
        return false;
      }

      if (filters?.location !== 'all' && job?.location?.toLowerCase() !== filters?.location?.toLowerCase()) {
        return false;
      }

      if (filters?.category !== 'all' && job?.category !== filters?.category) {
        return false;
      }

      if (filters?.experience !== 'all') {
        const expMap = {
          'fresher': [0, 1],
          'entry': [1, 3],
          'mid': [3, 6],
          'senior': [6, 10],
          'lead': [10, 100]
        };
        const [min, max] = expMap?.[filters?.experience] || [0, 100];
        const jobExp = parseInt(job?.experience?.split('-')?.[0]);
        if (jobExp < min || jobExp > max) return false;
      }

      if (filters?.jobTypes?.length > 0 && !filters?.jobTypes?.includes(job?.jobType)) {
        return false;
      }

      const salaryMaxInLPA = filters?.salaryMax * 100000;
      if (job?.salaryMin > salaryMaxInLPA) {
        return false;
      }

      if (filters?.isRemote && !job?.isRemote) {
        return false;
      }

      if (filters?.companySize !== 'all' && job?.companySize !== filters?.companySize) {
        return false;
      }

      return true;
    });
  };

  const sortJobs = (jobs) => {
    const sorted = [...jobs];
    switch (sortBy) {
      case 'date-desc':
        return sorted?.sort((a, b) => new Date(b.postedDate) - new Date(a.postedDate));
      case 'date-asc':
        return sorted?.sort((a, b) => new Date(a.postedDate) - new Date(b.postedDate));
      case 'salary-desc':
        return sorted?.sort((a, b) => b?.salaryMax - a?.salaryMax);
      case 'salary-asc':
        return sorted?.sort((a, b) => a?.salaryMin - b?.salaryMin);
      case 'company-rating':
        return sorted?.sort((a, b) => (b?.applicants || 0) - (a?.applicants || 0));
      default:
        return sorted;
    }
  };

  const filteredJobs = filterJobs(mockJobs);
  const sortedJobs = sortJobs(filteredJobs);
  const totalPages = Math.ceil(sortedJobs?.length / jobsPerPage);
  const startIndex = (currentPage - 1) * jobsPerPage;
  const displayedJobs = sortedJobs?.slice(startIndex, startIndex + jobsPerPage);

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    setCurrentPage(1);
  };

  const handleClearFilters = () => {
    setFilters({
      keyword: '',
      location: 'all',
      experience: 'all',
      category: 'all',
      jobTypes: [],
      salaryMin: 0,
      salaryMax: 50,
      isRemote: false,
      companySize: 'all'
    });
    setCurrentPage(1);
  };

  const handleWishlistToggle = (jobId, isWishlisted) => {
    console.log(`Job ${jobId} wishlist status: ${isWishlisted}`);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Job Listings - Find Your Dream Job | JobPortal India</title>
        <meta name="description" content="Browse thousands of job opportunities across India. Filter by location, experience, salary, and more to find your perfect job match." />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />

        <main className="pt-20 pb-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="mb-6">
              <h1 className="text-2xl sm:text-3xl font-bold text-foreground mb-2">
                Explore Job Opportunities
              </h1>
              <p className="text-muted-foreground">
                Discover your next career move from thousands of opportunities across India
              </p>
            </div>

            <div className="lg:grid lg:grid-cols-12 lg:gap-6">
              <aside className="hidden lg:block lg:col-span-3">
                <div className="sticky top-24">
                  <FilterPanel
                    filters={filters}
                    onFilterChange={handleFilterChange}
                    onClearFilters={handleClearFilters}
                    isOpen={true}
                    onClose={() => {}} />

                </div>
              </aside>

              <div className="lg:col-span-9">
                <div className="mb-4 flex items-center justify-between lg:hidden">
                  <Button
                    variant="outline"
                    onClick={() => setIsFilterOpen(true)}
                    iconName="SlidersHorizontal"
                    iconPosition="left">

                    Filters
                  </Button>
                </div>

                <FilterPanel
                  filters={filters}
                  onFilterChange={handleFilterChange}
                  onClearFilters={handleClearFilters}
                  isOpen={isFilterOpen}
                  onClose={() => setIsFilterOpen(false)} />


                <div className="space-y-4">
                  <SortControls
                    totalResults={filteredJobs?.length}
                    currentSort={sortBy}
                    onSortChange={setSortBy} />


                  {displayedJobs?.length > 0 ?
                  <>
                      <div className="grid gap-4">
                        {displayedJobs?.map((job) =>
                      <JobCard
                        key={job?.id}
                        job={job}
                        onWishlistToggle={handleWishlistToggle} />

                      )}
                      </div>

                      {totalPages > 1 &&
                    <div className="bg-card border border-border rounded-lg p-4">
                          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                            <p className="text-sm text-muted-foreground">
                              Showing {startIndex + 1} to {Math.min(startIndex + jobsPerPage, sortedJobs?.length)} of {sortedJobs?.length} jobs
                            </p>

                            <div className="flex items-center gap-2">
                              <Button
                            variant="outline"
                            size="sm"
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            iconName="ChevronLeft"
                            iconPosition="left">

                                Previous
                              </Button>

                              <div className="flex items-center gap-1">
                                {[...Array(Math.min(totalPages, 5))]?.map((_, index) => {
                              let pageNum;
                              if (totalPages <= 5) {
                                pageNum = index + 1;
                              } else if (currentPage <= 3) {
                                pageNum = index + 1;
                              } else if (currentPage >= totalPages - 2) {
                                pageNum = totalPages - 4 + index;
                              } else {
                                pageNum = currentPage - 2 + index;
                              }

                              return (
                                <button
                                  key={pageNum}
                                  onClick={() => handlePageChange(pageNum)}
                                  className={`w-8 h-8 sm:w-10 sm:h-10 rounded-lg text-sm font-medium transition-smooth ${
                                  currentPage === pageNum ?
                                  'bg-primary text-primary-foreground' :
                                  'bg-muted text-muted-foreground hover:bg-muted/80'}`
                                  }>

                                      {pageNum}
                                    </button>);

                            })}
                              </div>

                              <Button
                            variant="outline"
                            size="sm"
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            iconName="ChevronRight"
                            iconPosition="right">

                                Next
                              </Button>
                            </div>
                          </div>
                        </div>
                    }
                    </> :

                  <EmptyState onClearFilters={handleClearFilters} />
                  }
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>);

};

export default JobListings;